<div class="customer_facing_header" [attr.aria-disabled]="trapFocusForCato">
  <nav id="ge5p_z1" aria-label="Site menu" class="ge5p_z1-navbar ng-scope" role="navigation">
     <header style="display: block;">
        <div id="gn-customer-facing">
           <nav id="navbar-customer1" class="navbar-customer1" name="globalnav" aria-label="Global Header">
              <div class="row">
                 <div id="customer-facing-navbar" class="fn-ds2">
                    <div class="z1-desktop-identity pull-left span4-xsm span4-sm span5-md span8">
                       <div id="z1-globe" class="hide-xsm hide-sm">
                          <a class="brand" aria-label="FirstNet" title="FirstNet"
                             href="{{cfetNavLinks.header_links.firstnet_home_page}}" target="_blank" rel="noopener">
                             <span id="z1-globe-md" class="icon-firstnet" aria-label="FirstNet" role="img"></span>
                          </a>
                       </div>
                       <div id="navLinks" class="horizontalParsys">
                          <a id="navchildLink1" class="navchildLinks" [ngClass]= "isLandingPage ? 'navlinkslanding' : ''"
                             href="{{cfetNavLinks.header_links.header_about_link}}"
                             target="_blank" rel="noopener">{{cfetNavLables.header_links.header_about}}</a>
                          <a id="navchildLink2" class="navchildLinks" [ngClass]= "isLandingPage ? 'navlinkslanding' : ''"
                             href="{{cfetNavLinks.header_links.header_devices_link}}"
                             target="_blank" rel="noopener">{{cfetNavLables.header_links.header_devices}}</a>
                          <a id="navchildLink3" class="navchildLinks" [ngClass]= "isLandingPage ? 'navlinkslanding' : ''"
                             href="{{cfetNavLinks.header_links.header_plans_link}}"
                             target="_blank" rel="noopener">{{cfetNavLables.header_links.header_plans}}</a>
                          <a id="navchildLinkOffers" class="navchildLinks" [ngClass]= "isLandingPage ? 'navlinkslanding' : ''"
                             href="{{cfetNavLinks.header_links.header_offers_link}}"
                             target="_blank" rel="noopener">{{cfetNavLables.header_links.header_offers}}</a>
                          <a id="navchildLinkagency" class="navchildLinks"
                             href="{{cfetNavLinks.header_links.header_agency_signup}}"
                             target="_blank" rel="noopener">{{cfetNavLables.header_links.header_agency_signup}}</a>
                       </div>
                    </div>
                    <div id="z1-mobile-identity" class="span4-xsm span4-sm hide-md hide-lg">
                       <a class="brand" title="FirstNet" target="_blank" rel="noopener"
                          href="{{cfetNavLinks.header_links.firstnet_home_page}}">
                          <span id="z1-mobile-globe" class="icon-firstnet" aria-label="FirstNet" role="img"></span>
                       </a>
                       <div class="pull-right span4-xsm span4-sm span6-md span4 text-right">
                          <a id="navmobileLink1" class="navmobileLinks" *ngIf="isLandingPage"
                             href="{{cfetNavLinks.header_links.check_eligibility_link}}">{{cfetNavLables.header_links.header_check_eligibility}}</a>
                       </div>
                    </div>
                    <div
                       class="desktoplinks z1-desktop-identity pull-right span4-xsm span4-sm span6-md span4 text-right">
                       <div class="horizontalParsys">
                          <a id="navchildLink4" class="navchildLinks"
                             [ngClass]="{'headernavlandingpage': isLandingPage, 'headernavpage': !isLandingPage}"
                             href="{{cfetNavLinks.header_links.header_have_questions}}"
                             target="_blank" rel="noopener">{{cfetNavLables.header_links.header_questions}}
                          </a>
                          <span id="headerLine1" class="headerLine" *ngIf="isLandingPage"></span>
                          <a id="navchildLink5" class="navchildLinks" *ngIf="isLandingPage"
                             href="{{cfetNavLinks.utf_header_links.check_eligibility_link}}">
                             {{cfetNavLables.header_links.header_check_eligibility}}
                          </a>
                       </div>
                    </div>
                    <div class="clearfix"></div>
                 </div>
              </div>
           </nav>
        </div>
     </header>
  </nav>
</div>